import { type MouseEvent, useCallback } from 'react';

import { useTooltipPinned } from './store/selectors.js';
import { useSetTooltipState } from './store/use-set-tooltip-state.js';

export const useTooltipHandlers = () => {
  const {
    setTooltipStateVisibility,
    setTooltipStatePosition,
    toggleTooltipStatePinned,
  } = useSetTooltipState();
  const isTooltipPinned = useTooltipPinned();

  const onMouseEnterHandler = useCallback(
    () => setTooltipStateVisibility(true),
    [setTooltipStateVisibility],
  );

  const onMouseMoveHandler = useCallback(
    (event: MouseEvent<SVGGElement>) => {
      const { clientX, clientY } = event;

      const position = {
        x: clientX,
        y: clientY,
      };

      setTooltipStatePosition(position);
      setTooltipStateVisibility(true);
    },
    [setTooltipStatePosition, setTooltipStateVisibility],
  );

  const onMouseLeaveHandler = useCallback(
    () => !isTooltipPinned && setTooltipStateVisibility(false),
    [isTooltipPinned, setTooltipStateVisibility],
  );

  const onMouseClickHandler = useCallback(
    (event: MouseEvent<SVGGElement>) => {
      event.stopPropagation();
      toggleTooltipStatePinned();
    },
    [toggleTooltipStatePinned],
  );

  return {
    onMouseEnterHandler,
    onMouseMoveHandler,
    onMouseLeaveHandler,
    onMouseClickHandler,
  };
};
